import { apiCall } from '../../services/apiUtil';

export const predictionsAPI = {
  predict: async ({ sportId, player1Id, player2Id, player3Id, player4Id }) => {
    return apiCall('/predictions/match', {
      method: 'POST',
      body: JSON.stringify({
        sportId,
        player1Id,
        player2Id,
        ...(player3Id && { player3Id }),
        ...(player4Id && { player4Id }),
      }),
    });
  },

  getSupportedSports: async () => {
    const res = await apiCall('/predictions/supported-sports');
    return { pro: res?.pro || [], kynaix: res?.kynaix || [] };
  },

  // Predicts every match in `matches` with a single request. Each entry needs
  // a caller-supplied matchId (echoed back so results can be matched up) plus
  // the same fields as predict().
  predictMatches: async (matches) => {
    const res = await apiCall('/predictions/matches', {
      method: 'POST',
      body: JSON.stringify({ matches }),
    });
    return res?.results || [];
  },
};
